import React from "react";
import { type LucideIcon } from "lucide-react";

interface WhyChooseCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

const WhyChooseCard: React.FC<WhyChooseCardProps> = ({
  icon: Icon,
  title,
  description,
}) => (
  <div className="flex h-full flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg dark:border-slate-700 dark:bg-slate-800 dark:hover:border-slate-600">
    <div className="grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-secondary to-[#2A1A66] text-gold">
      <Icon className="h-6 w-6" />
    </div>
    <h3 className="text-xl font-extrabold leading-tight tracking-tight text-gray-900 dark:text-white">
      {title}
    </h3>
    <p className="text-base font-light leading-relaxed text-gray-600 dark:text-gray-400">
      {description}
    </p>
  </div>
);

export default WhyChooseCard;
